import React from 'react';
import { Button, CircularProgress, FormGroup, TextField } from '@material-ui/core';
import DatePicker from '../general/DatePicker';
import { Form, Field, Formik } from 'formik';
import moment from 'moment';

const FormReport = ({ onSubmit, users, loading }) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        startDate: '',
        endDate: '',
        user: ''
      }}
      validate={values => {
        let errors = {};

        if(!values.startDate) {
          errors.startDate = 'Campo obrigatório';
        }

        if(!values.endDate) {
          errors.endDate = 'Campo obrigatório';
        }

        if((values.endDate && values.startDate) && moment(values.startDate).unix() > moment(values.endDate).unix()) {
          errors.startDate = 'Data inválida';
        }

        return errors;
      }}
      render={({
        values,
        setFieldValue,
        errors,
        isValidating,
        handleSubmit,
        isValid,
        ...props
       }) => {

        return (
          <Form onSubmit={handleSubmit}>
            <FormGroup row sx={{ gap: 3, marginBottom: 3 }}>
              <Field
                label="De"
                name="startDate"
                value={values.startDate}
                inputFormat='DD/MM/YYYY'
                component={(props) => <DatePicker {...props} />}
                error={errors.startDate}
                onChange={(value) => {
                  if(moment(value).isValid()) {
                    setFieldValue('startDate', value)
                  }
                }}
              />
              <Field
                label="Até"
                name="endDate"
                value={values.endDate}
                inputFormat='DD/MM/YYYY'
                component={(props) => <DatePicker {...props} />}
                error={errors.endDate}
                onChange={(value) => {
                  if(moment(value).isValid()) {
                    setFieldValue('endDate', value)
                  }
                }}
              />
              <Field
                name="user"
                sx={{width: 266}}
                type="number"
                value={values.user}
                onChange={(e) => setFieldValue('user', e.target.value)}
                label="Usuário"
                component={TextField}
              />
            </FormGroup>

            {loading ? <CircularProgress/> : <Button variant="contained" disabled={!isValid} type="submit">Gerar e exportar</Button>}
          </Form>
        );
      }}
    />
  );
};

export default FormReport;
